import React, { useState, useEffect, useContext } from 'react';
import { useLocation } from 'react-router-dom';
import {
  Grid,
  Typography,
  Paper,
  TextField,
  Box,
  Button,
  Modal,
} from '@mui/material';
import { AuthUser } from '../../interfaces/Contexts';
import {SelectOptions, AppFilterFields} from '../../interfaces/Common';
import JobCard from '../../Components/JobCards';
import Filters from './Filters'; 
import { getJobs } from '../../Utils/apiService';
import { AuthContext } from '../../Helpers/Contexts/authContext';

const JobsViewAll: React.FC = () => {
  const location = useLocation();
  const { title, data } = location.state || { title: '', data: [] };
    const {
      state: { user },
    } = useContext(AuthContext);
 const userData = user as AuthUser;
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredJobs, setFilteredJobs] = useState(data);

  // States for Filter Modal
  const [filterOpen, setFilterOpen] = useState(false);
  const [selectedValues, setSelectedValues] = useState<any>({});
  const [jobFilterData, setJobFilterData] = useState<any>({});
    const [locations, setLocations] = useState<Array<SelectOptions>>([]);
      const [allAppliedData, setAllAppliedData] = useState([]);
   const [jobTrend, setJobTrend] = useState([]);
   const [appliedData, setAppliedData] = useState([]);
  const [jobsData, setJobsData] = useState<any>([]);
  const [allJobsData, setAllJobsData] = useState<any[]>(data);
    const [jobStatusFilter, setJobStatusFilter] = useState(false);
     const [filterData, setFilterData] = useState<AppFilterFields>({});
  const [myJobsData, setMyJobsData] = useState<any[]>([]); 
  const [bookmarksData, setBookmarksData] = useState<any[]>([]);
  const [allBookmarksData, setAllBookmarksData] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  // Search filter
  useEffect(() => {
    const filtered = data?.filter((job: any) =>
      job?.Job_Title__c?.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFilteredJobs(filtered);
  }, [searchTerm, data]);

  console.log(selectedValues, 'data123sdsfd');
  useEffect(() => {
    if (selectedValues?.Job_Title__c?.length > 0 || selectedValues?.Organization__r?.Name?.length === 0 || selectedValues?.Work_Place_Type__c?.length === 0 || selectedValues?.Posted_by?.length === 0 || selectedValues?.Location__c?.length === 0 || selectedValues?.Job_Type__c?.length === 0) {
      const filtered = data.filter((job: any) =>
        selectedValues?.Job_Title__c?.some((value: string) =>
          job.Job_Title__c?.toLowerCase().includes(value.toLowerCase())
        )
      );
      setFilteredJobs(filtered);
    }
      else if (selectedValues?.Organization__r?.Name?.length > 0) {
        const filtered = data.filter((job: any) =>
          selectedValues?.Organization__r?.Name?.some((value: string) =>
            job.Organization__r?.Name?.toLowerCase().includes(value.toLowerCase())
          )
        );
      setFilteredJobs(filtered);
    }
    else if (selectedValues?.Work_Place_Type__c?.length > 0) {
        const filtered = data.filter((job: any) =>
          selectedValues?.Work_Place_Type__c?.some((value: string) =>
            job.Work_Place_Type__c?.toLowerCase().includes(value.toLowerCase())
          )
        );
      setFilteredJobs(filtered);
    } 
    else if (selectedValues?.Posted_by?.length > 0) {
        const filtered = data.filter((job: any) =>
          selectedValues?.Posted_by?.some((value: string) =>
            job.Posted_by?.toLowerCase().includes(value.toLowerCase())
          )
        );
      setFilteredJobs(filtered);
    } 
    else if (selectedValues?.Location__c?.length > 0) {
        const filtered = data.filter((job: any) =>
          selectedValues?.Location__c?.some((value: string) =>
            job.Location__c?.toLowerCase().includes(value.toLowerCase())
          )
        );
      setFilteredJobs(filtered);
    } 
    else if (selectedValues?.Job_Type__c?.length > 0) {
        const filtered = data.filter((job: any) =>
          selectedValues?.Job_Type__c?.some((value: string) =>
            job.Job_Type__c?.toLowerCase().includes(value.toLowerCase())
          )
        );
      setFilteredJobs(filtered);
    } 
    else {
      setFilteredJobs(data);
    }
  }, [selectedValues, data]);
  
  const handleFilterCancellation = () => {
    setFilterOpen(false);
  };

  const handleDropDownChange = (e: any) => {
    setLoading(true);
    if (e.Posted_by === 'Anyone') {
      setFilteredJobs(allJobsData);
      setBookmarksData(allBookmarksData);
    } else if (e.Posted_by === 'myself') {
      setFilteredJobs(myJobsData);
      setBookmarksData(allBookmarksData);
    } else {
      const filtered = allJobsData.filter((job: any) => {
        return Object.entries(e).every(([key, value]) => {
          return job[key] === value;
        });
      });
      setFilteredJobs(filtered);
    }
    setLoading(false);
  };
console.log(jobFilterData, location.state, selectedValues, 'jobFilterData111');
useEffect(() => {
    if (location.state?.filters) {
      setJobFilterData(location.state.filters);
    }
  }, [location.state]);

  const handleFilterCells = (data: string, key: string, name: string) => {
    setJobStatusFilter(true);
    if (name === 'AllJobs') {
      const filterJobs = allJobsData.filter((job: any) => {
        return job[key]?.toLowerCase().includes(data.toLowerCase());
      });

      setJobsData(filterJobs);
    } else if (name == 'Applied') {
      const filterJobsApply = allAppliedData.filter((job: any) => {
        return job[key]?.toLowerCase().includes(data.toLowerCase());
      });
      setAppliedData(filterJobsApply);
    } else if (name == 'Saved') {
      const filterJobsSaved = allBookmarksData.filter((job: any) => {
        return job[key]?.toLowerCase().includes(data.toLowerCase());
      });
      setBookmarksData(filterJobsSaved);
    }
    setFilterData({ ...filterData, [key]: data });
  };
  const getJobDetails = () => {
      
      setLoading(true);
      getJobs(userData.applicantId)
        .then((res) => {
          console.log(res.data, 'SetFilterData');
          
          setLoading(false);
          setJobFilterData(res.data);
          setAllJobsData(res.data.allJobs);
          setJobsData(res.data.allJobs);
          setMyJobsData(res.data.myJobs);
          const jobTrends = res.data.jobTrends.split(',');
          setJobTrend(jobTrends);
          const locations = res.data.allJobs.map((job: any) => job.Location__c);
          const uniqueLocations: any = Array.from(new Set(locations.filter((location: any) => location !== null)));
          setLocations(uniqueLocations);
        })
        .catch((err) => {
          setLoading(false);
          console.error(err);
        });
    };
    const filterJobs = (jobs: any[], criteria: Record<string, any[]>, name: string) => {
        console.log('Filtering jobs with criteria:', criteria, 'for section:', name);
    
   
    
        if (name === 'Applied') {
          setAppliedData(filteredJobs);
        } else if (name === 'AllJobs') {
          setJobsData(filteredJobs);
        } else if (name === 'Saved') {
          setBookmarksData(filteredJobs);
        }
    
        setLoading(false);
        // setSelectedValues([]);
      };
       useEffect(() => {
          getJobDetails();  
        }, []);

        console.log(filteredJobs, 'filteredJobs123');
        
    
  return (
    <Paper
      elevation={3}
      sx={{
        backgroundColor: '#fff',
        padding: 3,
        borderRadius: 2,
        minHeight: '100vh',
        position: 'relative',
      }}
    >
        <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
      <Typography variant="h5" fontWeight={600} mb={2} textAlign="start">
        {title}
      </Typography>
      <Box display="flex" justifyContent="center" >
        <Button
          variant="contained"
          sx={{
            backgroundColor: '#E8EBF3',
            color: 'white',
            textTransform: 'none',
            boxShadow: 'none',
            '&:hover': {
              backgroundColor: '#d3d7e3',
            },
          }}
          onClick={() => setFilterOpen(true)}
        >
          Filter
        </Button>
      </Box>
      </div>
      {/* Search Input */}
      <Box mb={3} mt={2}>
        <TextField
          fullWidth
          variant="outlined"
          placeholder="Search by job title"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          sx={{ backgroundColor: '#F5F5F5' }}
        />
      </Box>

      {/* Job Grid */}
      <Grid container spacing={2}>
        {filteredJobs?.length > 0 ? (
          filteredJobs.map((val: any, index: number) => (
            <Grid item xs={6} sm={6} md={4} key={val.Id}>
              <JobCard
                value={val}
                userData={{}}
                isBookmarked={false}
                onBookmarkClick={() => {}}
                setIsBookmarked={() => {}}
              />
            </Grid>
          ))
        ) : (
          <Typography sx={{ ml: 2, mt: 2 }}>No jobs found.</Typography>
        )}
      </Grid>
      <Modal
  open={filterOpen}
  onClose={handleFilterCancellation}
  aria-labelledby="modal-modal-title"
  aria-describedby="modal-modal-description"
>
  
<Filters
                      handleClose={handleFilterCancellation}
                      jobFilterData={jobFilterData}
                      selectedValues={selectedValues}
                      setSelectedValues={setSelectedValues}
                      setLoading={setLoading}
                      handleDropDownChange={(e: any) => {
                        setLoading(true);
                        console.log('e435asdas', e, jobFilterData);
                        if (e.Posted_by == 'Anyone') {
                          setJobsData(allJobsData);
                          setBookmarksData(allBookmarksData);
                          setLoading(false);
                          // setSelectedValues([]);
                        } else if (e.Posted_by == 'myself') {
                          setJobsData(myJobsData);
                          setBookmarksData(allBookmarksData);
                          setLoading(false);
                          // setSelectedValues([]);
                        } else {
                          delete e?.Salary;
                          filterJobs(allJobsData, e, 'AllJobs');
                          filterJobs(allBookmarksData, e, 'Saved');
                          setLoading(false);
                          // setSelectedValues([]);
                        }
                      }}
                    />

</Modal>


    </Paper>
  );
};

export default JobsViewAll;
